// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.organisation-create-backdrop {
  position: fixed;
  inset: 0;
  z-index: 1600;
  display: grid;
  place-items: center;
  padding: var(--space-4);
  background: var(--overlay-backdrop, rgba(13, 28, 26, 0.56));
}
.organisation-create-dialog {
  width: min(680px, 100%);
  max-height: calc(100dvh - 32px);
  overflow-y: auto;
  border: 1px solid var(--border-default);
  border-radius: var(--radius-lg);
  background: var(--surface-primary);
  color: var(--text-primary);
  box-shadow: var(--elevation-high);
}
.organisation-create-dialog > header,
.organisation-create-dialog > footer {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: var(--space-4);
  padding: var(--space-5) var(--space-6);
}
.organisation-create-dialog > header {
  border-bottom: 1px solid var(--border-subtle);
}
.organisation-create-dialog > header p {
  margin: var(--space-1) 0 0;
  color: var(--text-secondary);
}
.organisation-create-dialog > header button {
  border: 0;
  background: transparent;
  color: var(--text-primary);
}
.organisation-create-fields {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: var(--space-4);
  padding: var(--space-6);
}
.organisation-create-fields > label {
  display: grid;
  gap: var(--space-2);
}
.organisation-create-fields input {
  min-height: 42px;
  padding: var(--space-2) var(--space-3);
  border: 1px solid var(--border-default);
  border-radius: var(--radius-md);
  background: var(--surface-primary);
  color: var(--text-primary);
}
.organisation-create-fields small,
.organisation-create-error {
  color: var(--danger-text);
}
.organisation-create-error,
.organisation-create-abr {
  grid-column: 1 / -1;
}
.organisation-create-dialog > footer {
  justify-content: flex-end;
  border-top: 1px solid var(--border-subtle);
}
.organisation-create-dialog > footer button {
  min-height: 40px;
  padding: var(--space-2) var(--space-4);
  border-radius: var(--radius-md);
  font-weight: var(--font-weight-medium);
}
.organisation-create-dialog > footer .secondary {
  border: 1px solid var(--border-default);
  background: var(--surface-primary);
  color: var(--text-primary);
}
.organisation-create-dialog > footer .primary {
  border: 1px solid var(--interactive-default);
  background: var(--interactive-default);
  color: var(--on-interactive-primary);
}
@media (max-width: 640px) {
  .organisation-create-fields {
    grid-template-columns: minmax(0, 1fr);
    padding: var(--space-5);
  }
  .organisation-create-dialog > header,
  .organisation-create-dialog > footer {
    padding: var(--space-5);
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/OrganisationCreateDialog/organisationCreateDialog.css"],"names":[],"mappings":"AAAA;EACE,eAAe;EACf,QAAQ;EACR,aAAa;EACb,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,2DAA2D;AAC7D;AACA;EACE,uBAAuB;EACvB,+BAA+B;EAC/B,gBAAgB;EAChB,uCAAuC;EACvC,+BAA+B;EAC/B,kCAAkC;EAClC,0BAA0B;EAC1B,iCAAiC;AACnC;AACA;;EAEE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,mBAAmB;EACnB,sCAAsC;AACxC;AACA;EACE,6CAA6C;AAC/C;AACA;EACE,0BAA0B;EAC1B,4BAA4B;AAC9B;AACA;EACE,SAAS;EACT,uBAAuB;EACvB,0BAA0B;AAC5B;AACA;EACE,aAAa;EACb,gDAAgD;EAChD,mBAAmB;EACnB,uBAAuB;AACzB;AACA;EACE,aAAa;EACb,mBAAmB;AACrB;AACA;EACE,gBAAgB;EAChB,sCAAsC;EACtC,uCAAuC;EACvC,+BAA+B;EAC/B,kCAAkC;EAClC,0BAA0B;AAC5B;AACA;;EAEE,yBAAyB;AAC3B;AACA;;EAEE,mBAAmB;AACrB;AACA;EACE,yBAAyB;EACzB,0CAA0C;AAC5C;AACA;EACE,gBAAgB;EAChB,sCAAsC;EACtC,+BAA+B;EAC/B,sCAAsC;AACxC;AACA;EACE,uCAAuC;EACvC,kCAAkC;EAClC,0BAA0B;AAC5B;AACA;EACE,4CAA4C;EAC5C,sCAAsC;EACtC,oCAAoC;AACtC;AACA;EACE;IACE,qCAAqC;IACrC,uBAAuB;EACzB;EACA;;IAEE,uBAAuB;EACzB;AACF","sourcesContent":[".organisation-create-backdrop {\n  position: fixed;\n  inset: 0;\n  z-index: 1600;\n  display: grid;\n  place-items: center;\n  padding: var(--space-4);\n  background: var(--overlay-backdrop, rgba(13, 28, 26, 0.56));\n}\n.organisation-create-dialog {\n  width: min(680px, 100%);\n  max-height: calc(100dvh - 32px);\n  overflow-y: auto;\n  border: 1px solid var(--border-default);\n  border-radius: var(--radius-lg);\n  background: var(--surface-primary);\n  color: var(--text-primary);\n  box-shadow: var(--elevation-high);\n}\n.organisation-create-dialog > header,\n.organisation-create-dialog > footer {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: var(--space-4);\n  padding: var(--space-5) var(--space-6);\n}\n.organisation-create-dialog > header {\n  border-bottom: 1px solid var(--border-subtle);\n}\n.organisation-create-dialog > header p {\n  margin: var(--space-1) 0 0;\n  color: var(--text-secondary);\n}\n.organisation-create-dialog > header button {\n  border: 0;\n  background: transparent;\n  color: var(--text-primary);\n}\n.organisation-create-fields {\n  display: grid;\n  grid-template-columns: repeat(2, minmax(0, 1fr));\n  gap: var(--space-4);\n  padding: var(--space-6);\n}\n.organisation-create-fields > label {\n  display: grid;\n  gap: var(--space-2);\n}\n.organisation-create-fields input {\n  min-height: 42px;\n  padding: var(--space-2) var(--space-3);\n  border: 1px solid var(--border-default);\n  border-radius: var(--radius-md);\n  background: var(--surface-primary);\n  color: var(--text-primary);\n}\n.organisation-create-fields small,\n.organisation-create-error {\n  color: var(--danger-text);\n}\n.organisation-create-error,\n.organisation-create-abr {\n  grid-column: 1 / -1;\n}\n.organisation-create-dialog > footer {\n  justify-content: flex-end;\n  border-top: 1px solid var(--border-subtle);\n}\n.organisation-create-dialog > footer button {\n  min-height: 40px;\n  padding: var(--space-2) var(--space-4);\n  border-radius: var(--radius-md);\n  font-weight: var(--font-weight-medium);\n}\n.organisation-create-dialog > footer .secondary {\n  border: 1px solid var(--border-default);\n  background: var(--surface-primary);\n  color: var(--text-primary);\n}\n.organisation-create-dialog > footer .primary {\n  border: 1px solid var(--interactive-default);\n  background: var(--interactive-default);\n  color: var(--on-interactive-primary);\n}\n@media (max-width: 640px) {\n  .organisation-create-fields {\n    grid-template-columns: minmax(0, 1fr);\n    padding: var(--space-5);\n  }\n  .organisation-create-dialog > header,\n  .organisation-create-dialog > footer {\n    padding: var(--space-5);\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
